import {
	getChapterByPageGroupId,
	getPageByElementId,
	getParentEntityByPageId
} from '@editor2/components/CourseChangesDiff/helpers';
import {
	getEntityStringByNgType,
	getIncomingParent,
	getParentByEntityType,
	restoreDeletedPage,
	restoreDeletedPageGroup
} from '@editor2/services/conflictResolutionService';
import { ChangesStatus } from '@editor2/types/changesStatus';
import { NgTraditional } from '@editor2/types/ngTraditional';

export const filterByEntityId = (ids: string[], entityId: string) => {
	return ids.filter((id) => id !== entityId);
};

export const handleNewInAcceptCurrentReorder = ({ state, addedOrMovedFrom, childEntityType }) => {
	const entityString = getEntityStringByNgType(childEntityType);

	// if new in incoming - set as deleted in current
	addedOrMovedFrom.map((id) => {
		const isMovedFrom = getParentByEntityType(state, childEntityType, id);
		if (!isMovedFrom) state.changes[entityString][id] = [ChangesStatus.Deleted];
	});
};

export const handleDeletedInAcceptCurrentReorder = (data) => {
	const { state, deletedOrMovedTo, childEntityType, attribute } = data;
	const entityString = getEntityStringByNgType(childEntityType);

	// if deleted in incoming - set as new in current
	deletedOrMovedTo.map((id) => {
		const isMovedTo = getIncomingParent({ attribute, id, state });

		if (!isMovedTo) {
			const existsInCurrent = getParentByEntityType(state, childEntityType, id);
			if (existsInCurrent) state.changes[entityString][id] = [ChangesStatus.New];
		}
	});
};

export const handleNewInAcceptIncomingPagesReorder = ({ state, addedOrMovedFrom }) => {
	addedOrMovedFrom.map((pageId) => {
		const initialParent =
			getParentEntityByPageId(state.initialCourse.chapters, pageId) ||
			getParentEntityByPageId(state.initialCourse.page_groups, pageId);

		if (initialParent) {
			const initialIndex = initialParent.pages.indexOf(pageId);

			if (initialParent.type === NgTraditional.PageGroup) {
				const currentParentPages = state.page_groups.entities[initialParent.family_id].pages;
				state.page_groups.entities[initialParent.family_id].pages = [
					...currentParentPages.slice(0, initialIndex),
					pageId,
					...currentParentPages.slice(initialIndex)
				];
			} else if (initialParent.type === NgTraditional.Chapter) {
				const currentParentPages = state.chapters.entities[initialParent.family_id].pages;
				state.chapters.entities[initialParent.family_id].pages = [
					...currentParentPages.slice(0, initialIndex),
					pageId,
					...currentParentPages.slice(initialIndex)
				];
			}
		} else {
			state.changes.pages[pageId] = [];
		}
	});
};

export const handleDeletedInAcceptIncomingPagesReorder = ({ state, deletedOrMovedTo }) => {
	deletedOrMovedTo.map((pageId) => {
		const currentParent =
			getParentEntityByPageId(state.chapters, pageId) ||
			getParentEntityByPageId(state.page_groups, pageId);
		if (currentParent) {
			if (currentParent.type === NgTraditional.PageGroup) {
				const ids = state.page_groups.entities[currentParent.family_id].pages;
				state.page_groups.entities[currentParent.family_id].pages = filterByEntityId(ids, pageId);
			} else {
				const ids = state.chapters.entities[currentParent.family_id].pages;
				state.chapters.entities[currentParent.family_id].pages = filterByEntityId(ids, pageId);
			}
		} else {
			// if deleted - restore the page entity
			restoreDeletedPage(state, pageId);
			state.changes.pages[pageId] = [];
		}
	});
};

export const handleNewInAcceptIncomingPageGroupsReorder = ({ state, addedOrMovedFrom }) => {
	addedOrMovedFrom.map((pageGroupId) => {
		const initialParent = getChapterByPageGroupId(state.initialCourse.chapters, pageGroupId);
		const initialIndex = initialParent.page_groups.indexOf(pageGroupId);

		if (initialParent) {
			const currentParentPageGroups = state.chapters.entities[initialParent.family_id].page_groups;
			state.chapters.entities[initialParent.family_id].page_groups = [
				...currentParentPageGroups.slice(0, initialIndex),
				pageGroupId,
				...currentParentPageGroups.slice(initialIndex)
			];
		} else {
			state.changes.page_groups[pageGroupId] = [];
		}
	});
};

export const handleDeletedInAcceptIncomingPageGroupsReorder = ({ state, deletedOrMovedTo }) => {
	deletedOrMovedTo.map((pageGroupId) => {
		const currentParent = getChapterByPageGroupId(state.chapters, pageGroupId);

		if (currentParent) {
			const ids = state.chapters.entities[currentParent.family_id].page_groups;
			const filteredCurrent = filterByEntityId(ids, pageGroupId);

			state.chapters.entities[currentParent.family_id].page_groups = filteredCurrent;
		} else {
			// if deleted - restore the page group entity
			restoreDeletedPageGroup(state, pageGroupId);
		}
	});
};

export const handleAcceptCurrentElementsReorder = ({
	state,
	attribute,
	deletedOrMovedToInIncoming,
	adedOrMovedFromInIncoming
}) => {
	deletedOrMovedToInIncoming.map((elementId) => {
		const isMovedTo = getIncomingParent({ attribute, id: elementId, state });
		if (!isMovedTo) {
			const existsInCurrent = getPageByElementId(state.pages, elementId);
			if (existsInCurrent) {
				state.changes.elements[elementId] = [ChangesStatus.New];
			}
		}
	});

	adedOrMovedFromInIncoming.map((elementId) => {
		const isMovedFrom = getPageByElementId(state.pages, elementId);
		if (!isMovedFrom) {
			state.changes.elements[elementId] = [ChangesStatus.Deleted];
		}
	});
};

export const handleNewDeletedInCurrentElementsReorder = ({
	state,
	deletedOrMovedToInCurrent,
	addedOrMovedFromInCurrent
}) => {
	deletedOrMovedToInCurrent.map((elementId) => {
		const currentParent = getPageByElementId(state.pages, elementId);
		if (currentParent) {
			state.pages.entities[currentParent.family_id].elements = state.pages.entities[
				currentParent.family_id
			].elements.filter((id) => id !== elementId);
		} else {
			state.changes.elements[elementId] = [];
		}
	});

	addedOrMovedFromInCurrent.map((elementId) => {
		const initialParent = getPageByElementId(state.initialCourse.pages, elementId);

		if (initialParent) {
			const currentParentElements = state.pages.entities[initialParent.family_id].elements;
			const initialIndex = initialParent.elements.indexOf(elementId);

			state.pages.entities[initialParent.family_id].elements = [
				...currentParentElements.slice(0, initialIndex),
				elementId,
				...currentParentElements.slice(initialIndex)
			];
		} else {
			state.changes.elements[elementId] = [];
		}
	});
};
